// const port = "https://lifeline-server-production.up.railway.app/api/v1/"
const port = "https://api.lifelinemedicalsupply.net/api/v1/"
// const port = "http://localhost:8001/api/v1/"

export default port;
